import { render, staticRenderFns } from "./offload_report.vue?vue&type=template&id=56196ad4&"
import script from "./offload_report.vue?vue&type=script&lang=js&"
export * from "./offload_report.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports